'use client';

import classNames from 'classnames';

interface KeyboardShortcutTextProps {
  className?: string;
  shortcut: string;
}

const KeyboardShortcutText = ({ className, shortcut }: KeyboardShortcutTextProps) => {
  return (
    <kbd
      className={classNames(
        'flex h-[18px] w-[18px] items-center justify-center rounded-[4px] border border-[rgba(255,255,255,0.16)] bg-transparent text-white',
        className
      )}>
      {shortcut}
    </kbd>
  );
};

export default KeyboardShortcutText;
